import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles(() => ({
    root: {},
    grouped: {
        border: 0,
    },
    groupedHorizontal: {
        '&:not(:last-child)': {
            marginRight: '32px',
        },
    },
    toggleRoot: {
        border: 0,
        borderRadius: 0,
        textTransform: 'none',
        height: '24px',
        color: '#BAC0D0 !important',
        fontSize: '1rem',
        fontWeight: 400,
        padding: 0,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    toggleSelected: {
        fontWeight: '700 !important',
        color: '#1891F6 !important',
        backgroundColor: 'transparent !important',
        borderBottom: 'solid 2px #1891F6 !important',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
}), { name: 'program-dashboard-mode-selection' });